// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".title[data-v-26b9621a]{width:100%;height:58px;line-height:58px;text-align:center;background-color:#409eff;font-size:25px;font-weight:700;color:#fff;margin-top:3px}", ""]);
// Exports
module.exports = exports;
